<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
    id="changeOwnershipModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            :title="headerTitle"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>

                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="name">To User</label>
                      <validation-provider
                        #default="{ errors }"
                        name="referenceNumber"
                        rules="required"
                      >
                        <v-select
                            class="parent-ownership"
                            v-model="newOwnerId"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="users.to"
                            :reduce="full_name => full_name.id"
                            label="full_name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="name">Reference Number</label>
                      <validation-provider
                          #default="{ errors }"
                          name="referenceNumber"
                          rules="required"
                      >
                        <b-form-input
                            id="referenceNumber"
                            type="text"
                            v-model="newContract.referenceNumber"
                            name="referenceNumber"
                            :state="errors.length > 0 ? false:null"
                            placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="type">File</label>
                      <validation-provider
                          #default="{ errors }"
                          name="file"
                          rules=""
                      >
                        <b-form-file
                            ref="file"
                            v-model="newContract.file"
                            :file-name-formatter="formatNames"
                            accept=".pdf"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="startDate">Signing Date</label>
                      <validation-provider
                          #default="{ errors }"
                          name="actualEndDate"
                          rules=""
                      >
                        <template>
                          <b-form-datepicker
                              id="signing_date"
                              v-model="newContract.signing_date"
                              :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                              menu-class="w-100"
                              calendar-width="100%"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea, BFormDatepicker, BFormFile,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import projectService from '../../../../services/projectService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormDatepicker,
    BFormFile,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['contract'],
  data() {
    return {
      contractId: '',
      headerTitle: '',
      users: [],
      newOwnerId: '',
      newContract: {
        signing_date: '',
        referenceNumber: '',
        file: null,
      },
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        maxFiles: 1,
      },
      codeBasic,
      selected: '',
    }
  },
  mounted() {
    this.$watch(() => this.contract, contract => {
      this.contractId = contract.id
      console.log('====>', this.contractId )
      this.getUsers()
    })

  },
  methods: {
    getUsers() {
      this.loading = true
      projectService.getOwnerships(this.contractId).then(response => {
        this.users = response.data.data
        this.headerTitle = 'Change ' + this.users.owner.full_name +' Property'
        console.log(response.data.data)
        this.loading = false
      })
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              // this.editedContract.file = this.editedContract.file[0]

              projectService.changeOwnerships(this.contractId, this.newOwnerId, this.newContract )
                  .then(response => {

                    if(response && response.status === 200){
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Contract Property Is Changed Successfully !`,
                        },
                      })
                    }
                    $('#changeOwnershipModal').modal('hide')

                    this.$emit('refresh', 'true')

                    this.loading = false
                  })

            }})
    },
    resetDropzone(){
      this.$refs.createRef.removeAllFiles()

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
